<div fxFlex=100 fxFlex.lt-md=100 class="showcase-main-section">
    <div class="web-view">
        <!-- <div id="movie-cart" fxLayoutAlign="end end">
            <app-shopping-cart ></app-shopping-cart>

        </div>-->

        <div *ngIf="!errorApi && movieDisplayed">
            <div [id]="'movies'+movieDisplayed?.id" (click)="imgDetail(movieDisplayed)" #testScroll>
                <div class="web-background" style="background-image: url('{{movieDisplayed?.image}}');">
                </div>

            </div>
        </div>

        <div class="movieList" class="flex-item" fxLayout="row" *ngIf="!errorApi && movieDisplayed">
            <div style="z-index: auto !important;" class="img-container">

                <ng-container *ngFor="let movie of movieList">
                    <div class="img-div" [id]="'movies'+movie.id" (click)="imgDetail(movie)" #testScroll>
                        <img id="img" src="{{movie?.image}}">
                        <img class="waterMarked" [src]="officialLogo" alt="">
                    </div>
                </ng-container>
            </div>

            <div class="description-div">
                <h1 style="max-width: 30vw;">{{movieDisplayed?.name}}</h1>
                <hr width="20px">
                <div fxLayoutAlign="row" fxLayoutGap="30px">
                    <div *ngIf="movieDisplayed?.rating">{{movieDisplayed?.rating}}/10</div>
                    <div *ngIf="movieDisplayed?.duration">{{movieDisplayed?.duration}} mins</div>
                </div>
                <div class="paragraph-div">
                    <p [innerHTML]="movieDisplayed?.description"></p>
                    <div>
                        <p *ngIf="movieDisplayed?.cast">Starring {{movieDisplayed?.cast}}</p>
                    </div>
                    <div fxLayoutAlign="row" fxLayoutGap="30px">
                        <div>{{movieDisplayed?.language}}</div>
                        <div>{{movieDisplayed?.country}}</div>
                    </div>

                    <div class="button-div" fxLayout="row wrap" fxLayoutGap="10px">
                        <button *ngFor="let tags of movieDisplayed?.tags">{{tags}}</button>
                    </div>
                    <!-- <p>Official Selection of Cinejoy featuring Cinquest Artists{{movie.currentShowings[2]}}</p> -->
                    Official Selection of Cinejoy featuring Cinequest Artists March 21 - March 31, 2024 
                    <br />
                    <button class="movie_button" *ngIf="movieDisplayed?.showbuybutton"
                        (click)="openPaymentFlow(movieDisplayed?.id, movieDisplayed, 'Buy')">Buy Tks</button>
                    <button class="movie_button" *ngIf="movieDisplayed?.showwatchbutton"
                        [routerLink]="['/cinejoy/showcase/movie/stream/', movieDisplayed?.id, getmovieName(movieDisplayed.name)]">Watch</button>
                    <a #cd class="movie_button"
                        [routerLink]="['/cinejoy/showcase/moviepage', movieDisplayed?.id, getmovieName(movieDisplayed.name)]">Movie Page</a>
                    <button (click)="shareButton('facebook')" class="movie_button">
                        <i class="fa fa-facebook" aria-hidden="true"></i>
                        <meta name="description" content="Free Web tutorials f">
                    </button>

                    <button (click)="shareButton('twitter')" class="movie_button">
                        <i class="fa fa-twitter" aria-hidden="true"></i>
                        <meta name="description" content="Free Web tutorials f">
                    </button>

                </div>
            </div>
        </div>
        <ng-container *ngIf="errorApi">
            <div class="No-Movie-container" fxLayout="row wrap" fxLayoutAlign="center center">
                <p>No movies found. Please try different search results.</p>
            </div>
        </ng-container>
    </div>
    <div class="mobile-view">
        <div class="mob-background-img" fxLayoutAlign="space-between center">
            <!-- <div class="mobile-back-arrow">
                <img [routerLink]="['/showcase/']" [src]="backArrow">
            </div> -->
            <!-- <span>Shorts</span> -->
            <div></div>

        </div>
        <ng-container *ngIf="errorApi">
            <div class="No-Movie-container" fxLayout="row wrap" fxLayoutAlign="center center">
                <p>No movies found. Please try different search results.</p>
            </div>
        </ng-container>
        <div class="mobile-movie-card" *ngFor="let movie of movieList" fxLayout="row" [id]="'mobmovie'+movie.id">
            <div class="mob-img-div">
                <img src="{{movie.mobile_list_image}}" id="img1" alt="">
            </div>
            <div class="mob-description-div">
                <div class="mob-heading">{{movie.name}}</div>
                <div class="mob-ratings">{{movie.rating}}/10</div>

                <div fxLayout="row wrap" fxLayoutGap="5px">
                    <button class="mob-movie-btn" *ngIf="movie.showbuybutton"
                        (click)="openPaymentFlow(movie.id, movie , 'Buy')">Buy Tks</button>
                    <button type="button" class="mob-movie-btn" *ngIf="movie.showwatchbutton"
                        [routerLink]="['/cinejoy/showcase/movie/stream/', movie.id,getmovieName(movie.name)]">
                        Watch
                    </button>
                    <button class="mob-movie-btn"
                        [routerLink]="['/cinejoy/showcase/moviepage', movie.id, getmovieName(movie.name)]">Movie Page</button>
                    <button (click)="shareButton('facebook')" class="movie_button">
                        <i class="fa fa-facebook" aria-hidden="true"></i>
                        <meta name="description" content="Free Web tutorials f">
                    </button>

                    <button (click)="shareButton('twitter')" class="movie_button">
                        <i class="fa fa-twitter" aria-hidden="true"></i>
                        <meta name="description" content="Free Web tutorials f">
                    </button>

                </div>
            </div>
        </div>
    </div>
</div>